import controller from '../vd-badge.controller'
import template from './vd-user-badge.html'

/**
 * Component for displaying a user (avatar, display name, username). Currently used in the user switching modal.
 */
const UserBadgeComponent = {
  bindings: {
    current: '<?',
    highlight: '<?',
    hyperlink: '@?',
    interactive: '@?',
    size: '@?',
    user: '<',
  },
  controller,
  template,
}

export default UserBadgeComponent
